import {DataContentWrapper} from '@hconnect/common/containers'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {Box, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {StoppagesFailureChart} from '../components'
import {DOWNTIME_ANALYTICS_WIDGET_NAMESPACE} from '../consts'
import {useStoppagesFailureTypes} from '../hooks'

type StoppagesFailureChartContainerProps = {
  plantId: string
  from: Date
  to: Date
}

export const StoppagesFailureChartContainer = ({
  plantId,
  from,
  to
}: StoppagesFailureChartContainerProps) => {
  const {t} = useTranslation(DOWNTIME_ANALYTICS_WIDGET_NAMESPACE)
  const {data, isError, isLoading, refetch, isRefetching} = useStoppagesFailureTypes({
    plantId,
    from,
    to
  })

  return (
    <CardBox sx={{height: '100%', display: 'flex', flexDirection: 'column', minHeight: 400}}>
      <Stack sx={{mb: 2}}>
        <Typography variant="h3">{t('stoppagesFailureChart.cardTitle')}</Typography>
        <Typography variant="caption">{t('stoppagesFailureChart.cardSubtitle')}</Typography>
      </Stack>
      <DataContentWrapper
        showLoader={isLoading}
        data={data?.failureTypes}
        retryFunction={() => void refetch()}
        isError={isError}
        isRefetching={isRefetching}
        progressSx={{color: 'primary.main'}}
      >
        <Box sx={{flex: 1, display: 'flex'}}>
          <StoppagesFailureChart data={data} />
        </Box>
      </DataContentWrapper>
    </CardBox>
  )
}
